import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import UniprotPdbLinks from '@Components/Results/targets/UniprotPdbLinks';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import Synonyms from '@Components/Results/targets/Synonyms.jsx';

function TargetDetailsLeft({ subunits, onDetailsToggle, detailsExpanded, trackingAttrs }) {
  const getTrackingAttrs = () => ({
    ...trackingAttrs,
    'data-tracking': !detailsExpanded,
    'data-tracking-type': 'contentview,contentlinkclick',
    'data-tracking-action': 'target details',
  });

  const { getProteinName } = ReactTargetHelper;

  return (
    <div className="target-details-left">
      {subunits.length === 1 && <div className="protein-type">Single protein</div>}
      {subunits.length > 1 && <div className="protein-type">Protein complex - {subunits.length}</div>}
      <ul className="target-details-list">
        {subunits.map((protein, index) => (
          <li className="target-details-list-item" key={index}>
            <InnerHTML tag="h2" className="target-details-name u-els-font-size-h3" html={getProteinName(protein)} />
            {protein.synonyms && <Synonyms list={protein.synonyms} prefix="Synonyms: " separator=", " showCount />}
            {protein.mutantChimeraDetails && (
              <div className="target-external-wrapper">
                <span className="target-external-title">Mutant/chimera Details:</span>
                <span className="target-external-mutant">{protein.mutantChimeraDetails}</span>
              </div>
            )}
            {protein.uniprotsLinks && (
              <div className="target-external-wrapper">
                <UniprotPdbLinks
                  links={protein.uniprotsLinks}
                  heading="Uniprot"
                  headingClass=""
                  useShowMore
                  trackingAction="uniprot"
                  proteinType="single"
                  useSemicolon={false}
                  trackingAttrs={trackingAttrs}
                />
              </div>
            )}
          </li>
        ))}
      </ul>
      <button className="rx-btn rx-btn--small rx-btn--basic_link blue rx-btn--right" onClick={onDetailsToggle} {...getTrackingAttrs()}>
        <span className="rx-btn-text">
          <span className="rx-btn-text-container">
            <span className="rx-btn-text-container">{`${detailsExpanded ? 'Hide' : 'Show'} target details`}</span>
          </span>
        </span>
        <span className="rx-btn-icon">
          <i className={detailsExpanded ? 'ss-navigateup' : 'ss-navigatedown'} />
        </span>
      </button>
    </div>
  );
}

TargetDetailsLeft.propTypes = {
  subunits: PropTypes.array.isRequired,
  detailsExpanded: PropTypes.bool.isRequired,
  onDetailsToggle: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default TargetDetailsLeft;
